import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase/firebase";
import { setAdminLanguageByEmail } from "../utils/adminLanguage";
import "../auth/Login.css";

const Login = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (loading) return;

    setError("");
    setLoading(true);

    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email.trim(),
        password
      );

      setAdminLanguageByEmail(userCredential.user.email);

      navigate("/admin/add-car", { replace: true });
    } catch (err) {
      switch (err.code) {
        case "auth/invalid-credential":
          setError("Email or password is incorrect.");
          break;
        case "auth/user-not-found":
          setError("User not found.");
          break;
        case "auth/wrong-password":
          setError("Wrong password.");
          break;
        case "auth/invalid-email":
          setError("Invalid email address.");
          break;
        case "auth/configuration-not-found":
          setError("Email/Password authentication is not enabled.");
          break;
        case "auth/network-request-failed":
          setError("Network error. Please check your internet.");
          break;
        default:
          setError("Login failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="admin-login-page">
      <div className="admin-login-overlay"></div>

      <form className="admin-login-card" onSubmit={handleLogin}>
        <span className="admin-eyebrow">AutoPark Admin</span>

        <h1>Welcome Back</h1>

        <p className="admin-subtitle">
          Sign in to manage your dealership inventory.
        </p>

        {error && <div className="admin-error">{error}</div>}

        <div className="admin-field">
          <label>Email Address</label>
          <input
            type="email"
            placeholder="admin@email.com"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="admin-field">
          <label>Password</label>
          <input
            type="password"
            placeholder="Enter password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <button className="admin-login-btn" type="submit" disabled={loading}>
          {loading ? "Logging in..." : "Login to Dashboard"}
        </button>
      </form>
    </main>
  );
};

export default Login;